module.exports = __webpack_public_path__ + "img/GooglePlay.3267109e.jpg";